import type { AppCopy } from '../catalogs';

export const fiAppCopy = {
  welcomeHeading: 'Kuinka voin auttaa sinua tänään?',
  thinking: 'Ajatteleminen',
  scrollToBottom: 'Vieritä alas',
  reasoning: 'Päättely',
  reasoningInProgress: 'käynnissä',
  citationPages: 'Sivut {first}–{last}',
  citationTitle: 'Lähdeote',
  citationLoading: 'Ladataan lähdettä…',
  citationUnavailable: 'Viitattu teksti ei ole saatavilla tai käyttöoikeutesi on poistettu.',
  citationOpen: 'Avaa lähde',
  citationCopied: 'Lähdeviite kopioitu',
  copy: 'Kopioi',
  more: 'Lisää',
  tryAgain: 'Yritä uudelleen',
  answerTruncated: 'Vastaus saavutti pituusrajan ja katkesi.',
  continueAnswer: 'Jatka vastausta',
  exportMarkdown: 'Vie nimellä Markdown',
  edit: 'Muokkaa',
  cancel: 'Peruuta',
  update: 'Päivitä',
  previous: 'Edellinen',
  next: 'Seuraavaksi',
  messagePlaceholder: 'Lähetä viesti…',
  projectHomePlaceholder: 'Uusi chat: {project}',
  sharedChatEveryone: 'Kaikki yrityksessä {company} voivat lukea tämän keskustelun',
  sharedChatOnePerson: '1 henkilö voi lukea tämän keskustelun',
  sharedChatPeople: '{count} henkilöä voi lukea tämän keskustelun',
  forkedChatPlaceholder: 'Jatka omilla yhteyksilläsi…',
  newAnswer: 'Uusi vastaus',
  messageInput: 'Viestin syöttö',
  sendMessage: 'Lähetä viesti',
  stopGenerating: 'Lopeta tuottaminen',
  addAttachment: 'Lisää liite',
  removeFile: 'Poista tiedosto',
  attachmentPreview: 'Liitteen esikatselu',
  imageAttachmentPreview: 'Kuvaliitteen esikatselu',
  image: 'Kuva',
  openLink: 'avaa linkki',
  document: 'Asiakirja',
  file: 'Tiedosto',
  attachment: 'liite',
  uploadFailed: 'lataus epäonnistui',
  uploading: 'lataaminen',
  toolIncomplete: 'Keskeneräinen',
  toolActivity: 'Toiminta',
  activityThinking: 'Miettii…',
  activityWriting: 'Kirjoittaa…',
  activityWaiting: 'Odottaa hyväksyntääsi',
  activityStopped: 'Pysäytetty',
  activityCouldNotFinish: 'Ei voitu viedä loppuun',
  activitySources: 'lähdettä',
  activityShowThinking: 'Näytä ajattelu',
  activityOpen: 'Avaa toiminta',
  activitySteps: 'Vaiheet',
  activitySourcesTab: 'Lähteet',
  activityUnavailable: 'Tämä toiminta ei ole saatavilla.',
  activityInput: 'Syöte',
  activityOutput: 'Tuloste',
  activityNoSources: 'Vastaus ei sisältänyt lähdeviitteitä.',
  activityApprovedByReply: 'Hyväksytty vastauksellasi',

  toolRunning: 'Työskentelee',
  toolComplete: 'Valmis',
  toolNeedsApproval: 'Vaatii hyväksynnän',
  toolInput: 'Syöte',
  toolCall: 'työkalukutsu',
  toolCalls: 'työkalukutsuja',
  openMenu: 'Avaa valikko',
  closeMenu: 'Sulje valikko',
  close: 'Sulje',
  showInTextField: 'Näytä tekstikentässä',
  settings: 'Asetukset',
  appearance: 'Ulkoasu',
  themeLight: 'Vaalea',
  themeDark: 'Tumma',
  themeSystem: 'Järjestelmä',
  themeChoiceHelp:
    'Koskee kaikkia laitteitasi. Järjestelmä seuraa kunkin laitteen vaaleaa tai tummaa tilaa.',
  themeSaveFailed: 'Ulkoasua ei voitu tallentaa, joten se on ennallaan. Yritä uudelleen.',
  toolUsed: 'Käytetty työkalu',
  toolCancelled: 'Peruutettu työkalu',
  toolResult: 'Tulos:',
  toolError: 'Virhe:',
  toolCancelledReason: 'Peruutettu syy:',
  approvalAllow: 'Salli',
  approvalAlwaysAllow: 'Salli aina',
  approvalDeny: 'Estä',
  approvalAlwaysDeny: 'Estä aina',
  approvalConfirm: 'Vahvista',
  approvalBack: 'Takaisin',
  approvalApprovedResult: 'Käyttäjän hyväksymä',
  approvalDeniedResult: 'Käyttäjä esti työkalun suorittamisen',
  logout: 'Kirjaudu ulos',
  loginOrCreateAccount: 'Kirjaudu sisään / Luo tili',
  newChat: 'Uusi chat',
  untitledChat: 'Nimetön chat',
  previousChats: 'Aiemmat chatit',
  openChat: 'Avaa chat {title}',
  moreActionsForChat: 'Lisää toimintoja: {title}',
  chatActions: 'Chat-toiminnot',
  closeChatActions: 'Sulje chat-toiminnot',
  deleteChatQuestion: 'Poistetaanko chat?',
  deleteChatDescription: 'Chat "{title}" poistetaan pysyvästi.',
  deleteChat: 'Poista chat',
  keepChat: 'Säilytä keskustelu',
  delete: 'Poista',
  deleting: 'Poistetaan…',
  chatDeleteFailed: 'Keskustelua ei voitu poistaa. Yritä uudelleen.',
  settingsDescription: 'Mukauta, miten avustaja toimii puolestasi.',
  settingsDesktopDescription: 'Mukauta, kuinka avustaja vastaa sinulle.',
  personalization: 'Personointi',
  personalizationDescription: 'Mukauta ohjeita, joita avustaja noudattaa jokaisessa vastauksessa.',
  languageAndRegion: 'Kieli ja alue',
  languageAndRegionDescription: 'Valitse kieli ja aikavyöhyke.',
  memories: 'Muistoja',
  memoriesDescription: 'Tarkastele, muokkaa tai poista, mitä avustaja muistaa sinusta.',
  account: 'Tili',
  accountDescription: 'Hallinnoi tiliä ja poista tietosi pysyvästi.',
  backToSettings: 'Takaisin asetuksiin',
  closeSettings: 'Sulje asetukset',
  settingsCategories: 'Asetusluokat',
  yourSettings: 'Asetuksesi',
  dataAndAccount: 'Tiedot ja tili',
  viewAndManageMemories: 'Tarkastele ja hallinnoi, mitä avustaja muistaa',
  loginToUseMemories: 'Kirjaudu sisään käyttääksesi muistoja',
  manageOrDeleteAccount: 'Hallinnoi tai poista tiliä',
  unsavedChanges: 'Sinulla on tallentamattomia muutoksia',
  unsavedCloseDescription: 'Asetusten sulkeminen hylkää tällä sivulla tehdyt muutokset.',
  unsavedBackDescription: 'Palaaminen hylkää tällä sivulla tehdyt muutokset.',
  continueEditing: 'Jatka muokkaamista',
  discardChanges: 'Hylkää muutokset',
  saveChanges: 'Tallenna muutokset',
  localSettingsNote: 'Tallennettu tähän selaimeen. Kirjaudu sisään tallentaaksesi tilillesi.',
  personality: 'Persoonallisuus',
  personalityHelp: 'Mukautetut ohjeet, joita avustaja noudattaa jokaisessa vastauksessa',
  personalityPlaceholder:
    'Esimerkiksi: Ole ytimekäs ja konkreettinen. Asun Göteborgissa ja pidän kasvisruoasta.',
  timezone: 'Aikavyöhyke',
  searchTimezone: 'Hae aikavyöhykkeitä…',
  automaticBrowser: 'Automaattinen (selain)',
  saved: 'Tallennettu {date}',
  addMemory: 'Lisää muisto',
  newMemory: 'Uusi muisto',
  memoryPlaceholder: 'Esimerkiksi: Suosin lyhyitä ja konkreettisia vastauksia.',
  editMemory: 'Muokkaa muistoa',
  saveMemory: 'Tallenna muisto',
  deleteMemory: 'Poista muisto',
  memorySaveFailed: 'Muistia ei voitu tallentaa. Yritä uudelleen.',
  memoryLimitReached: 'Voit tallentaa enintään 50 muistoa. Poista yksi ennen uuden lisäämistä.',
  memoryInvalid: 'Muistot eivät voi sisältää linkkejä. Poista linkki ja yritä uudelleen.',
  memoryDeleteFailed: 'Muistia ei voitu poistaa. Yritä uudelleen.',
  memoryLoadFailed: 'Muistoja ei voitu ladata.',
  loadingMemories: 'Ladataan muistoja…',
  emptyMemories:
    'Assistentti tallentaa muistoja sinusta puhuessasi – mistä pidät, missä asut ja mitä teet. Voit tarkastella, muokata ja poistaa niitä täällä.',
  deleteAccountHelp:
    'Poista pysyvästi tili ja kaikki siihen liittyvät keskustelut, muistit ja asetukset.',
  deleteAccount: 'Poista tili',
  deleteAccountQuestion: 'Poistetaanko tili pysyvästi?',
  deleteAccountDescription:
    'Kaikki keskustelut, viestit, muistit, asetukset ja kirjautumistiedot poistetaan. Tätä toimintoa ei voi kumota.',
  deleteAccountConfirm: 'Kyllä, poista tilini',
  accountDeleteFailed: 'Tiliä ei voitu poistaa. Mitään ei poistettu – yritä uudelleen.',
  logoutEverywhereTitle: 'Kaikki laitteet',
  logoutEverywhereHelp:
    'Kirjaudu ulos kaikilla laitteilla ja selaimilla, joilla tilisi on auki, myös tällä.',
  logoutEverywhere: 'Kirjaudu ulos kaikkialta',
  logoutEverywhereQuestion: 'Kirjaudutaanko ulos kaikilla laitteilla?',
  logoutEverywhereDescription:
    'Sinun täytyy kirjautua uudelleen kaikilla laitteilla ja selaimilla, myös tällä. Keskustelusi ja asetuksesi säilyvät ennallaan.',
  loggingOut: 'Kirjaudutaan ulos…',
  logoutEverywhereFailed:
    'Emme voineet vahvistaa, että sinut kirjattiin ulos kaikkialta. Yritä uudelleen tai tarkista toiselta laitteelta, oletko yhä kirjautuneena.',
  settingsSaveFailed: 'Asetuksia ei voitu tallentaa. Yritä uudelleen.',
  customInstructions: 'Mukautetut ohjeet',
  notSet: 'Ei asetettu',
  automaticLanguage: 'Automaattinen kieli',
  automaticTimezone: 'automaattinen aikavyöhyke',
  appLanguage: 'Sovelluksen kieli',
  appLanguageHelp:
    'Ohjaa koko sovelluksen käyttöliittymää ja päivämääriä. Avustajan vastaukset noudattavat edelleen kieltä, jolla kirjoitat.',
  automaticBrowserLanguage: 'Automaattinen (selaimen kieli)',
  previousLanguageChoice: 'Edellinen valinta: {language} ({locale})',
  previousLanguageChoiceCode: 'Edellinen valinta ({locale})',
  canvasCopyLink: 'Kopioi linkki',
  canvasLinkCopied: 'Linkki kopioitu',
  actionUpdatedWithEdits: 'Päivitetty muutoksillasi',
  activityStepsDone: 'one:vaihe valmis|other:vaihetta valmiina',
  activityResultsCount: 'one:tulos|other:tulosta',
  canvasCopyLinkFailed: 'Linkkiä ei voitu kopioida',
  canvasOpenInAgent: 'Avaa sovelluksessa {agent}',
  canvasExpand: 'Laajenna',
  canvasExitFullView: 'Poistu koko näkymästä',
  webSourceUnread:
    'Linkitetty tässä vastauksessa. Poneva ei lukenut tätä sivua, joten tässä ei ole mitään näytettävää.',
  webSourceOpenOriginal: 'Avaa alkuperäinen',
  toolProgressSettings: 'Muutetaan asetuksiasi…',
  toolProgressAgent: 'Luodaan agenttia…',
  toolProgressConnections: 'Haetaan yhteysvaihtoehtoja…',
  toolProgressResult: 'Valmistellaan tulostasi…',
  toolProgressClarification: 'Valmistellaan tarkennusta…',
  toolProgressKnowledge: 'Valmistellaan ehdotettua tietopäivitystä…',
  toolProgressQuestion: 'Valmistellaan kysymystä sinulle…',
  toolProgressSkill: 'Muotoillaan Skilliäsi…',
  toolErrorSettings: 'Asetuksiasi ei muutettu.',
  toolErrorAgent: 'Agenttia ei voitu luoda.',
  toolErrorConnections: 'Yhteysvaihtoehtoja ei voitu ladata.',
  toolErrorResult: 'Tulosta ei tallennettu.',
  toolErrorClarification: 'Tarkennusta ei voitu valmistella.',
  toolErrorKnowledge: 'Ehdotettua tietopäivitystä ei voitu valmistella.',
  toolErrorQuestion: 'Kysymystä ei voitu valmistella.',
  toolErrorSkill: 'Skillin luonnosta ei voitu tallentaa.',
  toolErrorOpenSettings: 'Avaa Asetukset',
  toolErrorOpenAgents: 'Avaa Agentit',
  toolErrorOpenConnections: 'Avaa Yhteydet',
  toolStepIncomplete: 'Tämä vaihe ei valmistunut.',
  toolEarlierAttemptsFailed: 'one:aiempi yritys ei onnistunut|other:aiempaa yritystä ei onnistunut',
} satisfies AppCopy;
